// Textos dos botões do site, editáveis no painel (separador Textos → Botões do site).
// Cada um fica guardado no conteúdo do site com a chave indicada; vazio = texto por omissão.
export const BUTTON_TEXTS = [
  { key: "header_cta", label: "Botão do menu (computador)", fallback: "Aula experimental" },
  { key: "header_cta_short", label: "Botão do menu (telemóvel, curto)", fallback: "Marcar" },
  { key: "pricing_cta", label: "Botão dos planos de preços", fallback: "Quero saber mais" },
  { key: "instagram_cta", label: "Botão do Instagram (antes do @)", fallback: "Seguir" },
  { key: "contact_submit", label: "Botão de enviar a mensagem (aula experimental)", fallback: "Enviar por WhatsApp" },
  { key: "whatsapp_float", label: "Botão flutuante do WhatsApp", fallback: "WhatsApp" },
];

const FALLBACKS = Object.fromEntries(BUTTON_TEXTS.map(({ key, fallback }) => [key, fallback]));

export function buttonText(content, key) {
  const value = typeof content?.[key] === "string" ? content[key].trim() : "";
  return value || FALLBACKS[key];
}
